import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReceivablesImportRow} from "../../../../shared/interface/receivables-import-row";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {ReceivablesStatement} from "../../../../shared/interface/receivables-statement";
import {ActivatedRoute} from "@angular/router";
import {ReceivablesImportsRowService} from "../../../../shared/services/receivables-imports-row.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {ReceivablesStatementService} from "../../../../shared/services/receivables-statement.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {Document} from "../../../../shared/interface/document";
import {ListResponse} from "../../../../shared/interface/response/list-response";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {co} from "@fullcalendar/core/internal-common";

@Component({
  selector: 'app-receivables-statement-details',
  templateUrl: './receivables-statement-details.component.html',
  styleUrls: ['./receivables-statement-details.component.scss']
})
export class ReceivablesStatementDetailsComponent implements OnInit, OnDestroy {

  receivablesStatementId: string;
  receivablesStatementObject?: ReceivablesStatement;
  receivablesStatement: ReplaySubject<ReceivablesStatement> = new ReplaySubject<ReceivablesStatement>(1);
  receivablesImportRows: ReplaySubject<ReceivablesImportRow[]> = new ReplaySubject<ReceivablesImportRow[]>(1);
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private receivablesStatementService: ReceivablesStatementService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.receivablesStatementId = params.id;
        this.loadReceivablesStatement();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadReceivablesStatement(): void {
    this.receivablesStatementService.get(this.receivablesStatementId).subscribe((receivablesStatement: ReceivablesStatement) => {
      this.receivablesStatement.next(receivablesStatement);
      this.receivablesStatementObject = receivablesStatement;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });
    });
  }

  onTabChange(e: MatTabChangeEvent): void {
    if (e.index === 1) {
      this.loadReceivablesImportRows();
    }
  }
  loadReceivablesImportRows(): void {
    this.receivablesStatementService.getStatementReceivablesImportRows(this.receivablesStatementId)
      .subscribe((receivablesImportRows: ListResponse<ReceivablesImportRow>) => {
        this.receivablesImportRows.next(receivablesImportRows.items);
      });
  }
}
